export default __webpack_public_path__ + "static/media/tapicerowane4.4dae0841.jpg";